import React, { type ReactNode } from 'react';
import { type MapDispatchToProps, type MapStateToProps, connect } from 'react-redux';

import { AppContextIntegrationData } from '../../../lib/Context';
import { getCatalogDetailsForBackstage } from '../actions';
import * as D from '../deps';
import { isValidPandoraId } from '../utils';

export interface IBackstageRowColumnsStateProps {
  artistUrl?: ReturnType<typeof D.getBackstagePathForToken>;
  artistName?: string;
  imageUrl?: string;
  isImgCircle?: boolean;
  sourceCardMenuItems?: ReturnType<typeof D.getSourceCardMenuItems>;
}

export interface IBackstageRowColumnsDispatchProps {
  getCatalogDetailsForBackstage: typeof getCatalogDetailsForBackstage;
}

export interface IBackstageRowColumnsOwnProps {
  pandoraId?: string;
  useDarkTheme?: boolean;
}

export type IBackstageRowColumnsProps = IBackstageRowColumnsStateProps &
  IBackstageRowColumnsDispatchProps &
  IBackstageRowColumnsOwnProps;

export class BackstageRowColumns extends React.Component<IBackstageRowColumnsProps> {
  componentDidMount(): void {
    if (this.props.pandoraId && !this.props.artistUrl) {
      this.props.getCatalogDetailsForBackstage(this.props.pandoraId, true);
    }
  }

  getIntegrationData = (): { pandoraId: IBackstageRowColumnsProps['pandoraId'] } => {
    return {
      pandoraId: this.props.pandoraId,
    };
  };

  render(): ReactNode {
    return (
      <AppContextIntegrationData data={this.getIntegrationData}>
        <D.RowItem
          useDarkTheme={this.props.useDarkTheme}
          isImgCircle={this.props.isImgCircle}
          imgUrl={this.props.imageUrl}
          mainText={this.props.artistName}
          rowUrl={this.props.artistUrl}
          isWidthHalf={true}
          hasBorderTopBottom={true}
          sourceCardMenuItems={this.props.sourceCardMenuItems}
        />
      </AppContextIntegrationData>
    );
  }
}

export const mapStateToProps: MapStateToProps<
  IBackstageRowColumnsStateProps,
  IBackstageRowColumnsOwnProps,
  $TSFixMe
> = (state, ownProps) => {
  const props = {};
  const pandoraId = ownProps.pandoraId;
  let annotations;

  if (isValidPandoraId(pandoraId)) {
    annotations = D.getInDomain('catalog.utils.getAnnotations')(state, pandoraId);
    // @ts-expect-error TS(2339) FIXME: Property 'artistUrl' does not exist on type '{}'.
    props.artistUrl = D.getFromMap(annotations, 'shareableUrlPath');
  } else {
    // @ts-expect-error TS(2355) Argument of type 'string | undefined' is not assignable to parameter of type 'string'....
    annotations = D.Utils.Entity.getEntityById(state, pandoraId);
    // @ts-expect-error TS(2339) FIXME: Property 'artistUrl' does not exist on type '{}'.
    props.artistUrl =
      annotations && D.getBackstagePathForToken(D.getFromMap(annotations, 'seoToken'));
  }
  // @ts-expect-error TS(2339) FIXME: Property 'artistName' does not exist on type '{}'.
  props.artistName = D.getFromMap(annotations, 'name');
  const imageUrl = D.getArt(annotations, 300, state);
  // @ts-expect-error TS(2339) FIXME: Property 'imageUrl' does not exist on type '{}'.
  props.imageUrl = Object.keys(imageUrl).length !== 0 ? imageUrl : null;
  // @ts-expect-error TS(2339) FIXME: Property 'isImgCircle' does not exist on type '{}'... Remove this comment to see the full error message
  props.isImgCircle = typeof ownProps.isImgCircle !== 'undefined' ? ownProps.isImgCircle : true;
  // @ts-expect-error TS(2339) FIXME: Property 'sourceCardMenuItems' does not exist on t... Remove this comment to see the full error message
  props.sourceCardMenuItems = D.getSourceCardMenuItems({
    state,
    pandoraId,
    pandoraType: D.PandoraTypes.ARTIST,
    shareParentSource: {
      shareParentSourceId: pandoraId,
      shareParentSourceType: D.PandoraTypes.ARTIST,
    },
  });
  return props;
};

const mapDispatchToProps: MapDispatchToProps<
  IBackstageRowColumnsDispatchProps,
  IBackstageRowColumnsOwnProps
> = {
  getCatalogDetailsForBackstage,
};

export default connect(mapStateToProps, mapDispatchToProps)(BackstageRowColumns);
